<template>
    <div v-if="isPc" style="height: 100%;">
        <Heard />
        <div class="hero-page" ref="heroPageWrap" @mousemove="handleMouseMove" @mouseleave="handleMouseLeave">
            <canvas ref="starCanvas" class="star-canvas" data-prerender-canvas="true"></canvas>

            <div class="content-wrap">
                <div class="top-tip">
                    <span class="dot-blink"></span>
                    AI面试×悬赏招聘·AI分润制招聘平台
                </div>
                <h1 class="main-title">
                    人到面，<span class="color-purple">才付钱。</span>
                </h1>
                <p class="desc">
                    发布悬赏，AI 全网找人。
                    <br />
                    到面再结算，没结果全额退。
                </p>
                <div class="btn-group">
                    <!-- <button class="btn-primary" @click="goLogin">免费发布悬赏</button> -->
                    <button class="btn-primary" @click="goLogin">企业端登录</button>
                </div>
            </div>

            <div class="stats-wrap" ref="statsWrap">
                <div>
                    <div class="stat-item">
                        <div class="num">{{ statNum[0] }}<span class="unit">万+</span></div>
                        <div class="label">企业与机构用户</div>
                        <div class="sub-label">都在用的 AI 招聘底座 </div>
                    </div>
                    <div class="stat-item">
                        <div class="num">{{ statNum[1] }}<span class="unit">万+</span></div>
                        <div class="label">累计 AI 面试评估</div>
                        <div class="sub-label">场场都有结构化报告</div>
                    </div>
                    <div class="stat-item">
                        <div class="num">{{ statNum[2] }}<span class="unit">天</span></div>
                        <div class="label">平均交付周期</div>
                        <div class="sub-label">从发悬赏，到人到岗</div>
                    </div>
                    <div class="stat-item">
                        <div class="num">{{ statNum[3] }}<span class="unit">+</span></div>
                        <div class="label">职位胜任力模型</div>
                        <div class="sub-label">覆盖全行业主流岗位</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 完全不需要绑定动态class！直接读取全局css变量 -->

        <div class="content">
            <div class="top_1">
                <div class="why">
                    <div style="display: flex;align-items: center;margin-bottom: 21px;"><span class="span-title">01 /
                            为什么</span> <span
                            style="display: inline-block;width: 80px; height: 1px;background-color: #716C81;margin-left: 20px;"></span>
                    </div>
                    <h1 class="title_1">
                        他们卖曝光。<br><span style="color: #7C50FF ;">我们交到岗。 </span>
                    </h1>
                    <p class="desc">
                        广告费、年费、简历下载费。先收钱，人到没到岗没人管。<br>
                        我们只认一个口径：成功到面，才结算。
                    </p>
                    <div class="box_1">
                        <div class="left">
                            <div class="left_text">
                                <div class="h1_title">传统招聘</div>
                                <div v-for="(value, index) in sourceList" :key="index" class="item">
                                    <span
                                        style="width: 260px;margin-bottom: 25px;text-decoration-line: line-through;">{{
                                            value.title }}</span>
                                    <span><i class="el-icon-error" style="color:#FF3737"></i></span>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="h1_title">智面玄赏</div>
                            <div v-for="(value, index) in sourceList1" :key="index" class="item">
                                <span style="width: 400px;margin-bottom: 25px;">{{
                                    value.title }}</span>
                                <span><i class="el-icon-success" style="color:#09BE66"></i></span>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="two">
                    <div style="width: 1200px;margin: 0 auto;padding: 78px 32px;">
                        <div style="display: flex;align-items: center;margin-bottom: 21px;"><span class="span-title">02
                                / 双引擎</span> <span
                                style="display: inline-block;width: 80px; height: 1px;background-color: #716C81;margin-left: 20px;"></span>
                        </div>
                        <h1 class="title_1">AI 去找人。 <br><span style="color: #7C50FF ;">规则管住钱。 </span></h1>
                        <div class="box_2">
                            <div class="left">
                                <div class="title">
                                    <img src="https://file.zmxs.com.cn/img/2026-09-02140108.png" alt="">
                                    <span>引擎 A — AI 面试</span>
                                </div>
                                <div class="h1_title">
                                    <h3>别翻简历了，让 AI 先面。</h3>
                                    <span>数字面试官 7×24 在线，面完即出胜任力报告。</span>
                                </div>
                                <div class="ldChart">
                                    <div class="ld_title">
                                        <span class="dian"></span>
                                        <span class="text">Live · 面试进行中</span>
                                        <div
                                            style="height: 50px;display: flex; align-items: center; /* 核心：垂直居中！柱子中心点固定 */ gap: 4px; margin-left: 12px;flex-shrink: 0;">
                                            <span class="num" v-for="(scale, index) in scaleList" :key="index"
                                                :style="{ '--scale': scale }"></span>
                                        </div>
                                    </div>
                                    <div class="radar-box">
                                        <div ref="radarChart" data-prerender-canvas-container="true"
                                            style="width: 400px;height: 300px;"></div>
                                    </div>
                                    <div class="AiBtn" @click="goPath('talent')">
                                        了解AI面试
                                    </div>
                                </div>
                            </div>
                            <div class="left" style="border: none;padding-right: 10px;">
                                <div class="title">
                                    <img src="https://file.zmxs.com.cn/img/2026-09-02140108.png" alt="">
                                    <span>引擎 B — 悬赏招聘</span>
                                </div>
                                <div class="h1_title">
                                    <h3>人不到岗，不花一分钱。</h3>
                                    <span>发布悬赏，AI 全网匹配，揭榜网络并行推荐。<br>难招岗位专家攻坚，过程全程可追踪。</span>
                                </div>
                                <div class="card" ref="processCard">
                                    <!-- 去掉直接写死的动画类，初始不带动画 -->
                                    <div class="bg-gradient-bar" :class="{ barAnimate: cardInView }"></div>
                                    <!-- 流程步骤 -->
                                    <div class="step-wrap">
                                        <!-- 步骤1 -->
                                        <div class="step-item">
                                            <div class="img-box">
                                                <img src="https://file.zmxs.com.cn/img/2026-09-02140109.png" alt="">
                                                <span>发布</span>
                                            </div>
                                        </div>
                                        <!-- 箭头 -->
                                        <div class="arrow">
                                            <i class="el-icon-right"></i>
                                        </div>

                                        <!-- 步骤2 -->
                                        <div class="step-item">
                                            <div class="img-box">
                                                <img src="https://file.zmxs.com.cn/img/2026-09-02140110.png" alt="">
                                                <span>匹配</span>
                                            </div>
                                        </div>
                                        <div class="arrow">
                                            <i class="el-icon-right"></i>
                                        </div>

                                        <!-- 步骤3 -->
                                        <div class="step-item">
                                            <div class="img-box">
                                                <img src="https://file.zmxs.com.cn/img/2026-09-02140111.png" alt="">
                                                <span>面试</span>
                                            </div>
                                        </div>
                                        <div class="arrow">
                                            <i class="el-icon-right"></i>
                                        </div>

                                        <!-- 步骤4，最后一项无箭头 -->
                                        <div class="step-item">
                                            <div class="img-box">
                                                <img src="https://file.zmxs.com.cn/img/2026-09-02140112.png" alt="">
                                                <span>入职</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="AiBtn" @click="gobountyRecruitment">
                                    了解悬赏招聘
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="why">
                    <div style="display: flex;align-items: center;margin-bottom: 21px;"><span class="span-title">03 /
                            核心能力</span> <span
                            style="display: inline-block;width: 80px; height: 1px;background-color: #716C81;margin-left: 20px;"></span>
                    </div>
                    <h1 class="title_1">单用，解决一环。<br><span style="color: #7C50FF ;"> 组合，跑通全程。 </span></h1>
                    <p class="desc">AI 面试提筛选，悬赏招聘推交付。<br>
                        就业舱把服务，布到你想要的地方。
                    </p>
                    <div class="feature-wrap">
                        <!-- 卡片1 -->
                        <div class="card_1">
                            <img src="https://file.zmxs.com.cn/img/2026-09-02140113.png" alt="">
                            <h3>AI面试</h3>
                            <p>GAN 深度学习，多模态融合。多轮对话，报告直出。</p>
                            <div class="link-btn" @click="goPath('talent')">了解详情 →</div>
                        </div>
                        <!-- 卡片2 -->
                        <div class="card_1">
                            <img src="https://file.zmxs.com.cn/img/2026-09-02140114.png" alt="">
                            <h3>全职位人才库</h3>
                            <p>1500+ 岗位建模，千万级行为数据。可检索、可下载、可推荐。</p>
                            <div class="link-btn" @click="goPath('interview')">了解详情 →</div>
                        </div>
                        <!-- 卡片3 -->
                        <div class="card_1">
                            <img src="https://file.zmxs.com.cn/img/2026-09-02140115.png" alt="">
                            <h3>智慧就业舱</h3>
                            <p>AI 面试、岗位发布、政策查询，装进一台可部署终端。高校、社区、机构皆可布点。</p>
                            <div class="link-btn" @click="goPath('employment')">了解详情 →</div>
                        </div>
                        <!-- 卡片4 -->
                        <div class="card_1">
                            <img src="https://file.zmxs.com.cn/img/2026-09-02140116.png" alt="">
                            <h3>悬赏招聘</h3>
                            <p>企业发悬赏，AI 匹配提效，专家协同攻坚。按成功到面结算。</p>
                            <div class="link-btn" @click="goPath('bountyRecruitment')">了解详情 →</div>
                        </div>
                    </div>

                </div>
                <div class="two1" ref="two1Wrap">
                    <div style="width: 1200px;margin: 0 auto;padding: 134px 32px;">
                        <div style="display: flex;align-items: center;margin-bottom: 21px;"><span class="span-title">04
                                / 怎么跑</span> <span
                                style="display: inline-block;width: 80px; height: 1px;background-color: #716C81;margin-left: 20px;"></span>
                        </div>
                        <h1 class="title_1" style="margin-bottom: 41px;">五步。从发布到入职， <br><span style="color: #7C50FF ;">
                                不绕路。 </span></h1>
                        <div style="position: relative;">
                            <img v-if="!isDark" style="width: 1180px;height: 277px;"
                                src="https://file.zmxs.com.cn/img/2026-09-02140117.png" alt="">
                            <img v-else style="width: 1180px;height: 277px;"
                                src="https://file.zmxs.com.cn/img/2026-09-02140118.png" alt="">
                            <!-- 添加动态class -->
                            <div class="line" :class="{ animateLine: lineAnimateActive }"></div>
                        </div>
                    </div>
                </div>
                <div class="why">
                    <div style="display: flex;align-items: center;margin-bottom: 21px;"><span class="span-title">05 /
                            结果案例</span> <span
                            style="display: inline-block;width: 80px; height: 1px;background-color: #716C81;margin-left: 20px;"></span>
                    </div>
                    <h1 class="title_1">数字不会陪你客套，<br><span style="color: #7C50FF ;"> 我们敢用真结果说话。 </span></h1>

                    <div class="card_item">
                        <!-- 左侧区域 -->
                        <div class="left-wrap">
                            <div class="big-num"><span class="span"><span
                                        style="font-family: CustomFont;font-weight: normal;">45天 </span></span> →
                                <span style="font-family: CustomFont;font-weight: bold;">11天</span>
                            </div>
                            <div class="desc-text">某新能源制造商 · 产线工程师 &nbsp;|&nbsp; 岗位交付率 91%</div>
                        </div>
                        <!-- 垂直分割线 -->
                        <div class="divider"></div>
                        <!-- 右侧列表区域 -->
                        <div class="right-wrap">
                            <div class="data-row">
                                <span class="text-label">校招高峰，单日 <span class="purple-num"
                                        style="font-family: CustomFont">1,200+</span>场标准化初面</span>
                            </div>
                            <div class="data-row">

                                <span class="text-label">高管岗发布 3 天，收到 <span class="purple-num"
                                        style="font-family: CustomFont">200+</span>份精准简历</span>
                            </div>
                            <div class="data-row">

                                <span class="text-label">文商旅高管岗，入职成本下降 <span class="purple-num"
                                        style="font-family: CustomFont">-58%</span></span>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="two1" style="height: auto;">
                    <div style="width: 1200px;margin: 0 auto;padding: 91px 20px 98px 32px;">
                        <div style="display: flex;align-items: center;margin-bottom: 21px;"><span class="span-title">06
                                /
                                新闻</span> <span
                                style="display: inline-block;width: 80px; height: 1px;background-color: #716C81;margin-left: 20px;"></span>
                        </div>
                        <h1 class="title_1">进展有声，<br><span style="color: #7C50FF ;"> 动态皆可循。 </span></h1>
                        <div class="feature-wrap">
                            <div v-for="item in homeNewsList" :key="item.id" class="news-card-mini"
                                :class="{ 'news-card-mini--dark': isDark }" @click="goNewsDetail(item)">
                                <div class="news-card-mini__media">
                                    <img :src="item.img" :alt="item.title">
                                </div>
                                <div class="news-card-mini__body">
                                    <div class="news-card-mini__meta">{{ item.publishTime }} 发布</div>
                                    <h3 class="news-card-mini__title">{{ item.title }}</h3>
                                    <p class="news-card-mini__desc">{{ item.description }}</p>
                                </div>
                            </div>
                            <div class="news-more-wrap">
                                <button class="news-more-btn" :class="{ 'news-more-btn--dark': isDark }"
                                    @click="goNews">进入新闻中心</button>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="why" style="height: auto;">
                    <div style="display: flex;align-items: center;margin-bottom: 21px;"><span class="span-title">07
                            /
                            常见问题</span> <span
                            style="display: inline-block;width: 80px; height: 1px;background-color: #716C81;margin-left: 20px;"></span>
                    </div>
                    <h1 class="title_1">还有疑问，<br><span style="color: #7C50FF ;"> 先看这几句。 </span></h1>
                    <div class="feature-wrap faq-wrap">
                        <div v-for="(item, index) in homeQuestions" :key="index" class="faq-item"
                            :class="{ 'faq-item--dark': isDark }" @click="toggleQuestion(index)">
                            <div class="faq-item__head">
                                <span class="faq-item__question">{{ item.question }}</span>
                                <span class="faq-item__icon">{{ item.show ? '−' : '+' }}</span>
                            </div>
                            <div v-if="item.show" class="faq-item__answer">{{ item.answer }}</div>
                        </div>
                    </div>

                </div>
                <div class="two2">
                    <div class="content-wrap1" style="padding-bottom: 50px;">
                        <!-- 左侧文字按钮 -->
                        <div style="width: 300px;  ">
                            <div @click="handleClick(1)" v-if="isDark"
                                style="display: flex;flex-direction: column;align-items: center;gap: 12px;">
                                <img src="https://file.zmxs.com.cn/img/2026-09-02140119.png" alt="" v-if="!openDoor"
                                    style="width: 168px;height: 285px;">
                                <img src="https://file.zmxs.com.cn/img/2026-09-02140120.png" alt="" v-else
                                    style="width: 168px;height: 285px;">
                                <div style="font-weight: 400;font-size: 17px;color: rgba(214,219,246,0.72);margin-top: 40px;"
                                    v-if="!openDoor">
                                    角落这盏灯后面，好像有人</div>
                                <div style="font-weight: 400;font-size: 17px;color: rgba(214,219,246,0.72);margin-top: 40px;"
                                    v-else>
                                    嘘——别打扰他干活
                                </div>

                            </div>
                        </div>
                        <div class="left-text">
                            <div class="title">
                                <span class="black-text">下一个到岗的，<br></span>
                                <span class="purple-text">就是你的心仪人选。</span>
                            </div>
                            <div class="sub-title">发一个悬赏试试。没结果，可退费。</div>
                            <div class="btn-group">
                                <button class="btn-primary" @click="goLogin">免费发布悬赏</button>
                                <button class="btn-outline" @click="goLogin">企业端登录</button>
                            </div>
                            <div class="link-row">
                                需要演示或咨询？
                                <span @click="aboutUs" class="link-text">联系顾问 →</span>
                            </div>
                        </div>

                        <!-- 右侧插画+文案 -->
                        <div class="right-illu">
                            <!-- 插画位置，可放入图片 -->
                            <div class="illus-box" @click="handleClick(2)" v-if="!isDark">
                                <img src="https://file.zmxs.com.cn/img/2026-09-02140121.png" alt="" v-if="!openDoor">
                                <img src="https://file.zmxs.com.cn/img/2026-09-02140122.png" alt="" v-else>

                            </div>
                            <div class="tip1" :class="{ show: showTip1 }" v-if="!isDark">候选人已经在门口等你</div>
                            <div class="tip2" :class="{ show: showTip2 }" v-if="!isDark">
                                <div>AI面试</div>
                                <div>面对面，直接聊</div>
                            </div>
                            <div class="tip3" :class="{ show: showTip3 }" v-if="!isDark">
                                <div>结构化报告已生成</div>
                                <div>随时可以开始</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <PageFooter />
    </div>
    <div v-else class="h5-home">
        <HeardLight />
        <div class="h5-hero-page">
            <canvas ref="starCanvas" class="star-canvas" data-prerender-canvas="true"></canvas>
            <div class="h5-hero-page__content">
                <div class="h5-hero-page__top-tip">AI面试×悬赏招聘·AI分润制招聘平台</div>
                <h1 class="h5-hero-page__title">
                    <span class="h5-hero-page__titleWhite">人到面，</span>
                    <span class="h5-hero-page__titleGradient">才付钱。</span>
                </h1>
                <div class="h5-hero-page__desc">
                    发布悬赏，AI 全网找人。
                    <br />
                    到面再结算，没结果全额退。
                </div>
                <div class="h5-hero-page__actions">
                    <button class="h5-hero-page__btn h5-hero-page__btn--primary" @click="goLogin">企业端登录</button>
                </div>
            </div>
            <div class="h5-hero-page__stats">
                <div class="h5-hero-page__stat">
                    <div class="h5-hero-page__num">{{ statNum[0] }}<span class="h5-hero-page__unit">万+</span></div>
                    <div class="h5-hero-page__label">企业与机构用户</div>
                </div>
                <div class="h5-hero-page__stat h5-hero-page__stat--glow">
                    <div class="h5-hero-page__num">{{ statNum[1] }}<span class="h5-hero-page__unit">万+</span></div>
                    <div class="h5-hero-page__label">累计 AI 面试评估</div>
                </div>
                <div class="h5-hero-page__stat">
                    <div class="h5-hero-page__num">{{ statNum[2] }}<span class="h5-hero-page__unit">天</span></div>
                    <div class="h5-hero-page__label">典型岗位平均交付周期</div>
                </div>
                <div class="h5-hero-page__stat">
                    <div class="h5-hero-page__num">{{ statNum[3] }}<span class="h5-hero-page__unit">+</span></div>
                    <div class="h5-hero-page__label">职位胜任力模型</div>
                </div>
            </div>
        </div>
        <div class="h5-why">
            <MobileHeroIntro variant="section" serial="01" subtitle="为什么" title-black="他们卖曝光。" title-purple="我们交到岗。"
                desc="广告费、年费、简历下载费。先收钱，人到没到岗没人管。<br />
                我们只认一个口径：成功到面，才结算。" />
            <MobileWhyProcessCompare top-title="传统招聘" :top-items="compareLeft" bottom-title="悬赏招聘"
                :bottom-items="compareRight" left="60px" />
        </div>
        <div class="h5-engine">
            <MobileHeroIntro variant="section" serial="02" subtitle="双引擎" title-black="AI去找人。" title-purple="规则管住钱。" />
            <div class="h5-engine__box">
                <div class="h5-engine__section h5-engine__section--interview">
                    <div class="h5-engine__head">
                        <img class="h5-engine__headIcon" src="https://file.zmxs.com.cn/img/2026-09-02140108.png" alt="">
                        <span class="h5-engine__headText">引擎 A－AI 面试</span>
                    </div>
                    <div class="h5-engine__title">别翻简历了，让 AI 先面。</div>
                    <div class="h5-engine__subTitle">数字面试官 7×24 在线，面完即出胜任力报告。</div>
                    <div class="h5-engine__live">
                        <span class="h5-engine__liveDot"></span>
                        <span class="h5-engine__liveText">LIVE · 面试进行中</span>
                        <div class="h5-engine__wave">
                            <span v-for="(scale, index) in scaleList" :key="index" class="h5-engine__waveBar"
                                :style="{ '--scale': scale }"></span>
                        </div>
                    </div>
                    <div class="h5-engine__radar">
                        <div ref="radarChart" data-prerender-canvas-container="true" class="h5-engine__radarCanvas">
                        </div>
                    </div>
                    <div class="h5-engine__btn" @click="goPath('talent')">了解AI面试</div>
                </div>
                <div class="h5-engine__section h5-engine__section--bounty">
                    <div class="h5-engine__head">
                        <img class="h5-engine__headIcon" src="https://file.zmxs.com.cn/img/2026-09-02140108.png" alt="">
                        <span class="h5-engine__headText">引擎 B－悬赏招聘</span>
                    </div>
                    <div class="h5-engine__title">人不到岗，不花一分钱。</div>
                    <div class="h5-engine__subTitle h5-engine__subTitle--wide">
                        发布悬赏，AI 全网匹配，揭榜网络并行推荐。<br />难招岗位专家攻坚，过程全程可追踪。
                    </div>
                    <div class="h5-engine__process" ref="processCard">
                        <div class="h5-engine__processGlow" :class="{ 'h5-engine__processGlow--active': cardInView }">
                        </div>
                        <div class="h5-engine__stepWrap">
                            <template v-for="(item, index) in engineProcessList">
                                <div :key="item.label" class="h5-engine__stepItem">
                                    <div class="h5-engine__stepIconWrap">
                                        <img class="h5-engine__stepIcon" :src="item.icon" :alt="item.label">
                                    </div>
                                    <div class="h5-engine__stepLabel">{{ item.label }}</div>
                                </div>
                                <div v-if="index < engineProcessList.length - 1" :key="`${item.label}-arrow`"
                                    class="h5-engine__arrow">
                                    <i class="el-icon-right"></i>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="h5-engine__btn" @click="gobountyRecruitment">了解悬赏招聘</div>
                </div>
            </div>
        </div>
        <div class="h5-core">
            <MobileHeroIntro variant="section" serial="03" subtitle="核心能力" title-black="单用，解决一环。"
                title-purple="组合，跑通全程。" desc="AI 面试提筛选，悬赏招聘推交付。<br />就业舱把服务，布到你想要的地方。" />
            <div class="h5-core__list">
                <div v-for="item in coreList" :key="item.title" class="h5-core__item">
                    <img class="h5-core__icon" :src="item.img" :alt="item.title">
                    <div class="h5-core__title">{{ item.title }}</div>
                    <div class="h5-core__desc">{{ item.desc }}</div>
                    <div class="h5-core__link" @click="goPath(item.path)">了解详情→</div>
                </div>
            </div>
        </div>
        <div class="h5-run">
            <MobileHeroIntro variant="section" serial="04" subtitle="怎么跑" title-black="五步。从发布到入职，" title-purple="不绕路。"
                desc="" />
            <div class="h5-run__imgWrap" ref="two1Wrap">
                <img class="h5-run__img" src="https://file.zmxs.com.cn/img/2026-09-0200013.png" alt="">
                <div class="h5-run__line" :class="{ 'h5-run__line--active': lineAnimateActive }"></div>
            </div>
        </div>
        <div class="h5-result">
            <MobileHeroIntro variant="section" serial="05" subtitle="结果案列" title-black="数字不会陪你客套，"
                title-purple="我们敢用真结果说话。" desc="" />
            <div class="h5-result__card">
                <div class="h5-result__top">
                    <div class="h5-result__headline">
                        <span class="h5-result__old">45天</span>
                        <span class="h5-result__arrow">→</span>
                        <span class="h5-result__new">11天</span>
                    </div>
                    <div class="h5-result__meta">某新能源制造商 · 产线工程师空窗期 ｜ 岗位交付率 91%</div>
                </div>
                <div class="h5-result__list">
                    <div class="h5-result__row">

                        <span class="h5-result__text">校招高峰，单日 <span class="h5-result__num">1,200+</span> 场标准化初面</span>
                    </div>
                    <div class="h5-result__row">
                        <span class="h5-result__text">高管岗发布 3 天，收到 <span class="h5-result__num">200+</span> 份精准简历</span>
                    </div>
                    <div class="h5-result__row">

                        <span class="h5-result__text">文商旅高管岗，入职成本下降<span class="h5-result__num">-58%</span></span>
                    </div>
                </div>
            </div>
        </div>
         <div class="h5-run">
            <MobileHeroIntro variant="section" serial="06" subtitle="新闻" title-black="进展有声，"
                title-purple="动态皆可循。" desc="公司动态与合作进展，官方同步。" />
            <div class="h5-news-grid">
                <div v-for="item in homeNewsListH5" :key="item.id" class="h5-news-grid__card"
                    :class="{ 'h5-news-grid__card--dark': isDark }" @click="goNewsDetail(item)">
                    <div class="h5-news-grid__media">
                        <img :src="item.img" :alt="item.title">
                    </div>
                    <div class="h5-news-grid__body">
                        <div class="h5-news-grid__meta">{{ item.publishTime }} 发布</div>
                        <h3 class="h5-news-grid__title">{{ item.title }}</h3>
                        <p class="h5-news-grid__desc">{{ item.description }}</p>
                    </div>
                </div>
            </div>
            <button class="h5-news-more" :class="{ 'h5-news-more--dark': isDark }" @click="goNews">进入新闻中心</button>
        </div>
        <div class="h5-result">
            <MobileHeroIntro variant="section" serial="07" subtitle="常见问题" title-black="还有疑问？"
                title-purple="先看这几句。" desc="" />
            <div class="h5-faq">
                <div v-for="(item, index) in homeQuestions" :key="index" class="h5-faq__item"
                    :class="{ 'h5-faq__item--dark': isDark }" @click="toggleQuestion(index)">
                    <div class="h5-faq__head">
                        <span class="h5-faq__question">{{ item.question }}</span>
                        <span class="h5-faq__icon">{{ item.show ? '−' : '+' }}</span>
                    </div>
                    <div v-if="item.show" class="h5-faq__answer">{{ item.answer }}</div>
                </div>
            </div>
        </div>
        <div class="h5-why-footer">
            <div class="h5-why-footer__inner">
                <div class="h5-why-footer__title">
                    <div class="h5-why-footer__titleBlack">下一个到岗的，</div>
                    <div class="h5-why-footer__titlePurple">就是你的心仪人选。</div>
                </div>
                <div class="h5-why-footer__desc">发一个悬赏试试。没结果，可退费。</div>
                <div class="h5-why-footer__actions">
                    <button class="h5-why-footer__btn h5-why-footer__btn--primary" @click="goLogin">免费发布悬赏</button>
                    <button class="h5-why-footer__btn h5-why-footer__btn--outline" @click="goLogin">企业端登录</button>
                </div>
                <div class="h5-why-footer__linkRow">
                    需要演示或咨询？
                    <span class="h5-why-footer__link" @click="aboutUs">联系顾问 →</span>
                </div>
            </div>
        </div>
        <PageFooter />
    </div>
</template>

<script>
import MobileHeroIntro from "./allTabs/bountyRecruitment/components/MobileHeroIntro.vue";
import MobileWhyProcessCompare from "./allTabs/bountyRecruitment/components/MobileWhyProcessCompare.vue";

import Heard from "@/components/newHead.vue";
import HeardLight from "@/components/newHead_light.vue";
import * as echarts from 'echarts'
import PageFooter from '@/components/newFooter.vue'
import { eventLog } from "@/utils/index.js";
import { determineDeviceType } from "@/plugins/untils.js";
import { getNewsList, questionList } from "@/apis/apis";

// 防抖工具函数
function debounce(fn, delay = 150) {
    let timer = null
    return function (...args) {
        const ctx = this
        clearTimeout(timer)
        timer = setTimeout(() => fn.apply(ctx, args), delay)
    }
}
import { resolveHref } from "@/multi/pageRoutes";

export default {
    name: 'HeroLanding',
    components: {
        HeardLight,
        Heard,
        PageFooter,
        MobileHeroIntro,
        MobileWhyProcessCompare
    },
    data() {
        return {
            isPc: true,
            lightAudio: null,
            lightAudio1: null,
            starList: [],
            canvasCtx: null,
            animationFrameId: null,
            animateFrame: null,
            coreList: [
                {
                    img: 'https://file.zmxs.com.cn/img/2026-09-0200009.png',
                    title: 'AI 面试',
                    desc: 'GAN 深度学习，多模态融合。多轮对话，报告直出。',
                    path: 'talent'
                },
                {
                    img: 'https://file.zmxs.com.cn/img/2026-09-0200010.png',
                    title: '全职位人才库',
                    desc: '1500+ 岗位建模，千万级行为数据。可检索、可下载、可推荐。',
                    path: 'interview'
                },
                {
                    img: 'https://file.zmxs.com.cn/img/2026-09-0200011.png',
                    title: '智慧就业舱',
                    desc: 'AI 面试、岗位发布、政策查询，装进一台可部署终端。高校、社区、机构皆可布点。',
                    path: 'employment'
                },
                {
                    img: 'https://file.zmxs.com.cn/img/2026-09-0200012.png',
                    title: '悬赏招聘',
                    desc: '企业发悬赏，AI 匹配提效，专家协同攻坚。按成功到面结算。',
                    path: 'bountyRecruitment'
                }
            ],
            compareLeft: [
                '先付费买曝光，结果看运气',
                '难招岗位，一拖就是几个月',
                '预算花完，人还没到岗',
                '过程不透明，无法复盘'
            ],
            compareRight: [
                '到面才结算；没结果，有条件全额退',
                'AI 全网匹配，推荐人可主动揭榜',
                '平均 9.5 天进入交付节奏',
                '难招岗位，专家可协同跟进'
            ],
            engineProcessList: [
                { label: '发布', icon: 'https://file.zmxs.com.cn/img/2026-09-02140109.png' },
                { label: '匹配', icon: 'https://file.zmxs.com.cn/img/2026-09-02140110.png' },
                { label: '面试', icon: 'https://file.zmxs.com.cn/img/2026-09-02140111.png' },
                { label: '入职', icon: 'https://file.zmxs.com.cn/img/2026-09-02140112.png' }
            ],
            mouse: {
                x: 0,
                y: 0,
                active: false,
                interactRadius: 140,
                linkRadius: 90,
                minLinkedStars: 5,
                expandStep: 36,
                auraRadius: 92,
                auraGap: 6,
            },
            cardInView: false,
            cardObserver: null,
            chart: null,
            count: 12,
            minHeight: 7,
            maxHeight: 40,
            heightList: [],
            scaleList: [],
            timer: null,
            statNum: [0, 0, 0, 0],
            statConfig: [
                { target: 12.86, decimals: 2 },
                { target: 3200, decimals: 0 },
                { target: 9.5, decimals: 1 },
                { target: 1500, decimals: 0 }
            ],
            animateDuration: 2000,
            statAnimateTriggered: false,
            sourceList: [
                {
                    title: '先付费买曝光，结果看运气',
                },
                {
                    title: '人工翻简历，一份 5–10 分钟',
                },
                {
                    title: '约面靠缘分，标准看心情',
                },
                {
                    title: '难招岗位，一拖就是几个月',
                }

            ],
            openDoor: false,
            showTip1: false,
            showTip2: false,
            showTip3: false,
            sourceList1: [
                {
                    title: '→ 到面才结算，无人到面全额退e',
                },
                {
                    title: '→ AI 秒级初筛，省去 63% 筛人时间',
                },
                {
                    title: '→ 7×24 AI 面试官，统一胜任力标准',
                },
                {
                    title: '→ 平均 9.5 天，进入交付节奏',
                }

            ],
            isDark: false,
            homeNewsList: [],
            homeNewsListH5: [],
            homeQuestions: [],
            lineAnimateActive: false,
            lineAnimateTriggered: false,
            observerStat: null,
            observerLine: null,
            resizeChartHandler: null,
            scaleRefreshHandler: null,
            heroResizeObserver: null
        }
    },
    created() {
        this.isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

        this.$root.$on('theme-updated', (darkVal) => {
            console.log('收到主题变更', darkVal)
            this.isDark = darkVal
        })
        this.isPc = determineDeviceType()
        this.getHomeNews()
        this.getHomeQuestions()
    },
    mounted() {
        this.lightAudio = new Audio(require('@/assets/light.mp3'))
        this.lightAudio1 = new Audio(require('@/assets/door.mp3'))

        this.lightAudio.preload = 'auto'
        this.lightAudio1.preload = 'auto'

        this.isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        this.animateFrame = () => this.animateStars();
        this.resizeChartHandler = debounce(() => {
            this.resizeChart()
        }, 180)
        this.scaleRefreshHandler = debounce(() => {
            this.handleResize()
            this.resizeChart()
        }, 80)

        this.initCanvas();
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('global-page-scale-changed', this.scaleRefreshHandler);

        this.$nextTick(() => {
            this.initStatObserver()
            this.initLineObserver()
            this.initCardObserver()
            this.setupHeroResizeObserver()
        })
        this.heightList = Array(this.count).fill(this.minHeight)
        this.startWave()
        this.initRadar()
        window.addEventListener('resize', this.resizeChartHandler)
    },
    beforeDestroy() {
        this.$root.$off('theme-updated')
        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
        }
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('global-page-scale-changed', this.scaleRefreshHandler);

        clearInterval(this.timer)
        window.removeEventListener('resize', this.resizeChartHandler)
        if (this.chart) this.chart.dispose()
        if (this.heroResizeObserver) this.heroResizeObserver.disconnect()
        // 销毁观察器，防止内存泄漏
        if (this.observerStat) this.observerStat.disconnect()
        if (this.observerLine) this.observerLine.disconnect()
        if (this.cardObserver) this.cardObserver.disconnect()

    },

    methods: {
        async getHomeNews() {
            try {
                const res = await getNewsList({
                    cateIds: '',
                    pageSize: 4,
                    currPage: 1,
                    isHot: 0,
                });
                const responseData = ((res || {}).data || {}).data || {};
                const list = responseData.list || [];
                this.homeNewsList = list.slice(0, 3);
                this.homeNewsListH5 = list.slice(0, 4);
            } catch (e) {
                this.homeNewsList = [];
                this.homeNewsListH5 = [];
            }
        },
        getHomeQuestions() {
            questionList({
                pageSize: 5,
            }).then(res => {
                if (res.data.code == '200') {
                    this.homeQuestions = (res.data.data.list || []).map(item => ({
                        show: false,
                        ...item
                    }));
                }
            }).catch(() => {
                this.homeQuestions = [];
            });
        },
        toggleQuestion(index) {
            const item = this.homeQuestions[index];
            if (item) {
                item.show = !item.show;
            }
        },
        goNewsDetail(item) {
            const newsId = item.id || item.newsId;
            if (!newsId) {
                return;
            }
            const href = resolveHref({
                name: 'newsdetails',
                params: { id: newsId }
            });
            window.location.assign(href);
        },
        goNews() {
            const href = resolveHref({ name: 'news' });
            window.location.assign(href);
        },
        gobountyRecruitment() {
            this.$router.push({ name: 'bountyRecruitment' })
        },
        aboutUs() {
            this.$router.push({ name: 'about-us', hash: 'contact' })
        },
        initCardObserver() {
            const cardDom = this.$refs.processCard;
            if (!cardDom) return;
            this.cardObserver = new IntersectionObserver((entries) => {
                const entry = entries[0];
                // intersectionRatio === 1 → 卡片100%全部进入视口
                if (entry.isIntersecting && entry.intersectionRatio >= 1 && !this.cardInView) {
                    this.cardInView = true;
                    this.cardObserver.disconnect();
                }
            }, {
                threshold: [1],
                // 可选微调，不想要偏移就删掉rootMargin
                // rootMargin: '0px'
            })
            this.cardObserver.observe(cardDom)
        },

        handleMouseMove(event) {
            const canvas = this.$refs.starCanvas;
            const container = this.$refs.heroPageWrap;
            const root = this.$el;
            if (!canvas || !container || !root) {
                return;
            }
            const rootRect = root.getBoundingClientRect();
            const { scaleX, scaleY } = this.getElementRenderScale(root, rootRect);
            const rootLocalX = (event.clientX - rootRect.left) / scaleX;
            const rootLocalY = (event.clientY - rootRect.top) / scaleY;

            this.mouse.x = rootLocalX - container.offsetLeft;
            this.mouse.y = rootLocalY - container.offsetTop;
            this.mouse.active = true;
        },
        handleMouseLeave() {
            this.mouse.active = false;
        },
        setupHeroResizeObserver() {
            if (typeof ResizeObserver === 'undefined' || !this.$refs.heroPageWrap) {
                return
            }

            this.heroResizeObserver = new ResizeObserver(() => {
                this.scaleRefreshHandler()
            })
            this.heroResizeObserver.observe(this.$refs.heroPageWrap)
        },
        getElementRenderScale(target, rect = null) {
            if (!target) {
                return {
                    scaleX: 1,
                    scaleY: 1
                }
            }

            const currentRect = rect || target.getBoundingClientRect()
            const baseWidth = target.clientWidth || target.offsetWidth || currentRect.width || 1
            const baseHeight = target.clientHeight || target.offsetHeight || currentRect.height || 1

            return {
                scaleX: currentRect.width / baseWidth || 1,
                scaleY: currentRect.height / baseHeight || 1
            }
        },
        clearPrerenderSnapshot(target) {
            if (!target) {
                return;
            }

            target.removeAttribute('data-prerender-image');
            target.style.backgroundImage = '';
            target.style.backgroundRepeat = '';
            target.style.backgroundPosition = '';
            target.style.backgroundSize = '';
        },
        initCanvas() {
            const canvas = this.$refs.starCanvas;
            if (!canvas) {
                return;
            }
            this.clearPrerenderSnapshot(canvas);
            this.canvasCtx = canvas.getContext("2d");
            this.handleResize();
        },
        createStars(width, height) {
            const isMobileHero = !this.isPc;
            const starCount = isMobileHero ? 96 : 70;
            return Array.from({ length: starCount }, (_, index) => {
                const baseTwinkleSpeed = Math.random() * 0.015 + 0.008;
                const baseMoveSpeed = Math.random() * 0.12 + 0.03;
                const baseSwaySpeed = Math.random() * 0.00008;
                return {
                    id: `star-${index}`,
                    x: Math.random() * width,
                    y: Math.random() * height,
                    radius: isMobileHero ? Math.random() * 1.4 + 0.8 : Math.random() * 1.1 + 0.5,
                    glowRadius: isMobileHero ? Math.random() * 3 + 2.4 : Math.random() * 2 + 1.5,
                    alpha: isMobileHero ? Math.random() * 0.4 + 0.45 : Math.random() * 0.45 + 0.35,
                    alphaDirection: Math.random() > 0.5 ? 1 : -1,
                    speed: baseTwinkleSpeed,
                    maxAlpha: isMobileHero ? Math.random() * 0.2 + 0.82 : Math.random() * 0.3 + 0.7,
                    minAlpha: isMobileHero ? Math.random() * 0.16 + 0.22 : Math.random() * 0.18 + 0.15,
                    moveSpeed: baseMoveSpeed,
                    driftBaseX: Math.random() * width,
                    swayAmplitude: isMobileHero ? Math.random() * 1.2 + 0.5 : Math.random() * 0.5 + 0.2,
                    swaySpeed: baseSwaySpeed,
                    driftOffset: Math.random() * Math.PI * 2,
                };
            });
        },
        handleResize() {
            const canvas = this.$refs.starCanvas;
            const container = this.$refs.heroPageWrap || (canvas && canvas.parentNode);
            if (!canvas || !container) {
                return;
            }
            const rect = container.getBoundingClientRect();
            const { scaleX, scaleY } = this.getElementRenderScale(container, rect);
            const dpr = window.devicePixelRatio || 1;
            canvas.width = Math.max(1, Math.round(container.clientWidth * dpr * scaleX));
            canvas.height = Math.max(1, Math.round(container.clientHeight * dpr * scaleY));
            this.canvasCtx.setTransform(dpr * scaleX, 0, 0, dpr * scaleY, 0, 0);
            this.starList = this.createStars(
                container.clientWidth,
                container.clientHeight
            );
            this.startAnimation();
        },
        startAnimation() {
            if (this.animationFrameId) {
                cancelAnimationFrame(this.animationFrameId);
            }
            this.animateFrame();
        },
        getInteractiveStars(width, height) {
            if (!this.mouse.active) {
                return {
                    selectedIds: new Set(),
                    selectedStars: [],
                    dynamicLinkRadius: this.mouse.linkRadius,
                };
            }
            const maxRadius = Math.hypot(width, height);
            const distanceList = this.starList
                .map((star) => ({
                    id: star.id,
                    x: star.x,
                    y: star.y,
                    distance: Math.hypot(star.x - this.mouse.x, star.y - this.mouse.y),
                }))
                .sort((a, b) => a.distance - b.distance);

            let currentRadius = this.mouse.interactRadius;
            let selectedStars = distanceList.filter(
                (star) => star.distance <= currentRadius
            );

            while (
                selectedStars.length < this.mouse.minLinkedStars &&
                currentRadius < maxRadius
            ) {
                currentRadius += this.mouse.expandStep;
                selectedStars = distanceList.filter(
                    (star) => star.distance <= currentRadius
                );
            }

            if (selectedStars.length > 8) {
                selectedStars = selectedStars.slice(0, 8);
            }

            return {
                selectedIds: new Set(selectedStars.map((star) => star.id)),
                selectedStars,
                dynamicLinkRadius: Math.max(
                    this.mouse.linkRadius,
                    currentRadius * 0.82
                ),
            };
        },
        drawStar(x, y, star, isHighlighted = false) {
            const glowRadius = isHighlighted
                ? star.glowRadius * 1.45
                : star.glowRadius;
            const coreRadius = isHighlighted ? star.radius * 1.35 : star.radius;
            const glowOpacity = isHighlighted ? star.alpha * 0.78 : star.alpha * 0.45;
            const midOpacity = isHighlighted ? star.alpha * 0.28 : star.alpha * 0.12;
            const gradient = this.canvasCtx.createRadialGradient(
                x,
                y,
                0,
                x,
                y,
                glowRadius
            );
            gradient.addColorStop(0, `rgba(255,255,255,${glowOpacity})`);
            gradient.addColorStop(0.55, `rgba(255,255,255,${midOpacity})`);
            gradient.addColorStop(1, "rgba(255,255,255,0)");

            this.canvasCtx.beginPath();
            this.canvasCtx.fillStyle = gradient;
            this.canvasCtx.arc(x, y, glowRadius, 0, Math.PI * 2);
            this.canvasCtx.fill();

            this.canvasCtx.beginPath();
            this.canvasCtx.fillStyle = `rgba(255,255,255,${Math.min(
                star.alpha + (isHighlighted ? 0.42 : 0.18),
                1
            )})`;
            this.canvasCtx.arc(x, y, coreRadius, 0, Math.PI * 2);
            this.canvasCtx.fill();
        },
        drawMouseAura() {
            if (!this.mouse.active) {
                return;
            }
            const { x, y, auraRadius, auraGap } = this.mouse;
            const bgGradient = this.canvasCtx.createRadialGradient(
                x,
                y,
                0,
                x,
                y,
                auraRadius * 1.2
            );
            bgGradient.addColorStop(0, "rgba(115, 82, 255, 0.16)");
            bgGradient.addColorStop(0.45, "rgba(92, 70, 222, 0.1)");
            bgGradient.addColorStop(1, "rgba(56, 42, 138, 0)");
            this.canvasCtx.beginPath();
            this.canvasCtx.fillStyle = bgGradient;
            this.canvasCtx.arc(x, y, auraRadius * 1.2, 0, Math.PI * 2);
            this.canvasCtx.fill();

            for (
                let offsetY = -auraRadius;
                offsetY <= auraRadius;
                offsetY += auraGap
            ) {
                for (
                    let offsetX = -auraRadius;
                    offsetX <= auraRadius;
                    offsetX += auraGap
                ) {
                    const distance = Math.hypot(offsetX, offsetY);
                    if (distance > auraRadius) {
                        continue;
                    }
                    const ratio = 1 - distance / auraRadius;
                    const dotAlpha = ratio * 0.5;
                    const dotSize = Math.max(1.8, ratio * 3.8);
                    this.canvasCtx.beginPath();
                    this.canvasCtx.fillStyle = `rgba(220, 210, 255, ${dotAlpha})`;
                    this.canvasCtx.arc(
                        x + offsetX,
                        y + offsetY,
                        dotSize / 2,
                        0,
                        Math.PI * 2
                    );
                    this.canvasCtx.fill();
                }
            }
        },
        drawMouseLinks(activeStars, linkRadius) {
            if (!this.mouse.active || activeStars.length === 0) {
                return;
            }
            activeStars.forEach((star) => {
                const mouseDistance = Math.hypot(
                    star.x - this.mouse.x,
                    star.y - this.mouse.y
                );
                const mouseAlpha = Math.max(
                    0.12,
                    (1 - mouseDistance / linkRadius) * 0.5
                );
                this.canvasCtx.beginPath();
                this.canvasCtx.moveTo(this.mouse.x, this.mouse.y);
                this.canvasCtx.lineTo(star.x, star.y);
                this.canvasCtx.strokeStyle = `rgba(255,255,255,${mouseAlpha})`;
                this.canvasCtx.lineWidth = 0.9;
                this.canvasCtx.stroke();
            });

            for (let i = 0; i < activeStars.length; i += 1) {
                for (let j = i + 1; j < activeStars.length; j += 1) {
                    const first = activeStars[i];
                    const second = activeStars[j];
                    const distance = Math.hypot(first.x - second.x, first.y - second.y);
                    if (distance > linkRadius) {
                        continue;
                    }
                    const alpha = (1 - distance / linkRadius) * 0.38;
                    this.canvasCtx.beginPath();
                    this.canvasCtx.moveTo(first.x, first.y);
                    this.canvasCtx.lineTo(second.x, second.y);
                    this.canvasCtx.strokeStyle = `rgba(255,255,255,${alpha})`;
                    this.canvasCtx.lineWidth = 0.8;
                    this.canvasCtx.stroke();
                }
            }

            this.canvasCtx.beginPath();
            this.canvasCtx.fillStyle = "rgba(255,255,255,0.95)";
            this.canvasCtx.arc(this.mouse.x, this.mouse.y, 2.2, 0, Math.PI * 2);
            this.canvasCtx.fill();

            this.canvasCtx.beginPath();
            this.canvasCtx.fillStyle = "rgba(255,255,255,0.18)";
            this.canvasCtx.arc(this.mouse.x, this.mouse.y, 6, 0, Math.PI * 2);
            this.canvasCtx.fill();
        },
        animateStars() {
            const canvas = this.$refs.starCanvas;
            if (!canvas || !this.canvasCtx) {
                return;
            }
            const width = canvas.clientWidth;
            const height = canvas.clientHeight;
            const time = performance.now();
            const interaction = this.getInteractiveStars(width, height);
            this.canvasCtx.clearRect(0, 0, width, height);
            this.drawMouseAura();
            this.starList.forEach((star, index) => {
                star.alpha += star.speed * star.alphaDirection;
                if (star.alpha >= star.maxAlpha || star.alpha <= star.minAlpha) {
                    star.alphaDirection *= -1;
                }
                const isNearMouse = interaction.selectedIds.has(star.id);

                if (!isNearMouse) {
                    if (this.isPc) {
                        star.x += Math.cos(time * 0.0012 + star.driftOffset + index) * star.moveSpeed;
                        star.y += Math.sin(time * 0.001 + star.driftOffset + index) * star.moveSpeed * 0.7;
                    } else {
                        star.y += star.moveSpeed;
                        star.x = star.driftBaseX + Math.sin(time * star.swaySpeed + star.driftOffset) * (star.swayAmplitude * 18);
                    }
                }

                const wrapPadding = star.glowRadius + 2;
                if (star.x < -wrapPadding) star.x = width + wrapPadding;
                if (star.x > width + wrapPadding) star.x = -wrapPadding;
                if (star.y < -wrapPadding) star.y = height + wrapPadding;
                if (star.y > height + wrapPadding) {
                    star.y = -wrapPadding;
                    star.driftBaseX = Math.random() * width;
                    star.x = star.driftBaseX;
                }

                this.drawStar(star.x, star.y, star, isNearMouse);
            });
            this.drawMouseLinks(
                interaction.selectedStars,
                interaction.dynamicLinkRadius
            );
            this.animationFrameId = requestAnimationFrame(this.animateFrame);
        },
        goPath(name) {
            const href = resolveHref({
                name,
            });
            window.location.assign(href);
        },
        goLogin() {
            eventLog('click_free_try')
            if (this.isPc) {
                window.open('https://job.zmxs.com.cn')
            } else {
                window.open(window.jumpBUrl)
            }
        },
        handleClick(type) {
            if (type == 2) {
                this.lightAudio.currentTime = 0 // 重置到音频开头
                this.lightAudio.play().catch(err => {
                    console.warn('音频播放失败', err)
                })

            } else {
                this.lightAudio1.currentTime = 0 // 重置到音频开头
                this.lightAudio1.play().catch(err => {
                    console.warn('音频播放失败', err)
                })
            }
            if (this.openDoor) {
                this.openDoor = false
                this.showTip1 = false
                this.showTip2 = false
                this.showTip3 = false
                return
            }
            // ===== 开灯的时候播放音效 =====

            this.openDoor = true
            setTimeout(() => { this.showTip1 = true }, 300)
            setTimeout(() => { this.showTip2 = true }, 800)
            setTimeout(() => { this.showTip3 = true }, 1300)

        },
        initRadar() {
            const radarDom = this.$refs.radarChart;
            if (!radarDom) {
                return;
            }
            this.clearPrerenderSnapshot(radarDom);
            this.chart = echarts.init(radarDom)
            const isMobile = !this.isPc;
            const option = {
                tooltip: { trigger: 'item' },
                radar: {
                    shape: 'polygon',
                    center: isMobile ? ['50%', '52%'] : [200, 140],
                    radius: isMobile ? '62%' : '68%',
                    indicator: [
                        { name: '专业', max: 100 },
                        { name: '推动', max: 100 },
                        { name: '执行', max: 100 },
                        { name: '沟通', max: 100 },
                        { name: '思考', max: 100 }
                    ],
                    splitNumber: 4,
                    axisName: { color: '#888888', fontSize: isMobile ? 14 : 18 },
                    splitLine: { lineStyle: { color: '#d3cde0' } },
                    splitArea: { show: false }
                },
                series: [
                    {
                        name: '能力雷达',
                        type: 'radar',
                        data: [
                            {
                                value: [90, 88, 100, 100, 87],
                                itemStyle: { color: '#7C50FF' },
                                areaStyle: { color: 'rgba(178, 145, 255, 0.4)' },
                                symbol: 'circle',
                                symbolSize: isMobile ? 5 : 8
                            }
                        ]
                    }
                ]
            }
            this.chart.setOption(option)
        },
        resizeChart() {
            if (this.chart) {
                this.chart.resize()
            }
        },
        startWave() {
            this.timer = setInterval(() => {
                this.heightList = this.heightList.map(() => {
                    return Math.floor(Math.random() * (this.maxHeight - this.minHeight) + this.minHeight)
                })
                this.scaleList = this.heightList.map(h => h / this.maxHeight)
            }, 120)
        },
        initStatObserver() {
            const wrapDom = this.$refs.statsWrap;
            if (!wrapDom) {
                setTimeout(() => {
                    if (!this.statAnimateTriggered) {
                        this.statAnimateTriggered = true;
                        this.runAllCountAnimation();
                    }
                }, 200)
                return;
            }
            this.observerStat = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && !this.statAnimateTriggered) {
                    this.statAnimateTriggered = true;
                    this.runAllCountAnimation();
                    this.observerStat.disconnect();
                }
            }, { threshold: 0.1 });
            this.observerStat.observe(wrapDom);
        },

        runAllCountAnimation() {
            console.log('开始数字动画')
            this.statConfig.forEach((item, index) => {
                this.startSingleCount(index, item.target, item.decimals)
            })
        },
        initLineObserver() {
            const dom = this.$refs.two1Wrap
            if (!dom) {
                setTimeout(() => {
                    if (!this.lineAnimateTriggered) {
                        this.lineAnimateTriggered = true
                        this.lineAnimateActive = true
                    }
                }, 300)
                return;
            }
            this.observerLine = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && !this.lineAnimateTriggered) {
                    this.lineAnimateTriggered = true
                    this.lineAnimateActive = true
                    this.observerLine.disconnect()
                }
            }, { threshold: 0.2 })
            this.observerLine.observe(dom)
        },
        startSingleCount(index, target, decimals) {
            const startTime = performance.now();
            const animate = (time) => {
                const elapsed = time - startTime;
                const progress = Math.min(elapsed / this.animateDuration, 1);
                const ease = 1 - Math.pow(1 - progress, 3);
                const currentVal = target * ease;
                this.$set(this.statNum, index, currentVal.toFixed(decimals));
                if (progress < 1) {
                    requestAnimationFrame(animate)
                }
            }
            requestAnimationFrame(animate)
        }
    }
}
</script>


<style scoped lang="less">
.hero-page {
    width: 100% !important;
    height: calc((100vh / var(--global-page-scale, 1)) - 72px);
    overflow-x: hidden;
    position: relative;
    background: url('https://file.zmxs.com.cn/img/2026-09-0800004.jpg') no-repeat;
    background-size: 100% 100%;
    padding: 0 !important;
    z-index: 1;

}

.star-canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    margin: 0;
    padding: 0;
    z-index: 0;
    pointer-events: none;
}

.content-wrap {
    position: absolute;
    top: 41%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999 !important;
    width: 92%;
    max-width: 1200px;
    text-align: center;
    box-sizing: border-box;
    margin: 0 auto;
}

.top-tip {
    font-weight: 700;
    font-size: 32px;
    color: #FFFFFF;
}

.dot-blink {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #b86cff;
    margin-right: 8px;
    vertical-align: middle;
    animation: blinkPurple 2s ease-in-out infinite;
}

.h5-home {
    .h5-hero-page {
        position: relative;
        overflow: hidden;
        padding: 118px 0 54px;
        background:
            radial-gradient(circle at 82% 12%, rgba(131, 82, 255, 0.32) 0%, rgba(131, 82, 255, 0.12) 22%, rgba(7, 14, 54, 0) 48%),
            radial-gradient(circle at 16% 62%, rgba(32, 91, 255, 0.16) 0%, rgba(32, 91, 255, 0.04) 26%, rgba(7, 14, 54, 0) 52%),
            linear-gradient(180deg, #060A26 0%, #040720 100%);

        .star-canvas {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: block;
            margin: 0;
            padding: 0;
            z-index: 0;
            pointer-events: none;
        }

        &__content {
            position: relative;
            z-index: 1;
            padding: 0 48px;
            text-align: center;
        }

        &__top-tip {
            font-size: 32px;
            line-height: 1.4;
            font-weight: 600;
            color: rgba(255, 255, 255, 0.92);
        }

        &__title {
            margin: 40px 0 0;
            display: flex;
            justify-content: center;
            align-items: baseline;
            flex-wrap: wrap;
        }

        &__titleWhite,
        &__titleGradient {
            font-size: 80px;
            line-height: 1.02;
            font-weight: 800;
            letter-spacing: -2px;
        }

        &__titleWhite {
            color: #F6F7FF;
        }

        &__titleGradient {
            background: linear-gradient(90deg, #129CFF 0%, #5E78FF 38%, #9F58FF 72%, #D75BFF 100%);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            -webkit-text-fill-color: transparent;
        }

        &__desc {
            margin: 40px auto 0;
            max-width: 530px;
            font-size: 32px;
            line-height: 1.65;
            font-weight: 500;
            color: rgba(219, 216, 233, 0.82);
        }

        &__descStrong {
            font-weight: 800;
            color: #FFFFFF;
        }

        &__actions {
            margin-top: 52px;
            display: flex;
            justify-content: center;
            gap: 16px;
        }

        &__btn {
            border-radius: 999px;
            padding: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            line-height: 1;
            font-weight: 700;
            cursor: pointer;
        }

        &__btn--primary {
            border: none;
            color: #FFFFFF;
            background: linear-gradient(270deg, #6B3AFF 0%, #8B18FF 100%);
            box-shadow: 0px 16px 34px rgba(107, 58, 255, 0.4);
        }

        &__btn--outline {
            border: 1px solid rgba(132, 137, 178, 0.36);
            color: rgba(240, 242, 255, 0.82);
            background: rgba(8, 13, 38, 0.38);
            backdrop-filter: blur(4px);
        }

        &__stats {
            position: relative;
            z-index: 1;
            margin-top: 92px;
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            border-top: 1px solid rgba(255, 255, 255, 0.08);
            border-left: 1px solid rgba(255, 255, 255, 0.08);
        }

        &__stat {
            position: relative;
            min-height: 244px;
            padding: 48px 32px 42px 44px;
            border-right: 1px solid rgba(255, 255, 255, 0.08);
            border-bottom: 1px solid rgba(255, 255, 255, 0.08);
            background: rgba(4, 8, 32, 0.28);
        }

        &__stat--glow::before {
            content: '';
            position: absolute;
            inset: 0;
            background: radial-gradient(circle at 56% 24%, rgba(151, 102, 255, 0.28) 0%, rgba(151, 102, 255, 0.1) 34%, rgba(4, 8, 32, 0) 70%);
            pointer-events: none;
        }

        &__num {
            position: relative;
            z-index: 1;
            font-family: 'CustomFont';
            font-size: 74px;
            line-height: 1;
            color: #FFFFFF;
            font-weight: 700;
            letter-spacing: -1px;
        }

        &__unit {
            margin-left: 4px;
            font-size: 28px;
            color: #A15DFF;
        }

        &__label {
            position: relative;
            z-index: 1;
            margin-top: 28px;
            font-size: 20px;
            line-height: 1.5;
            font-weight: 600;
            color: rgba(255, 255, 255, 0.82);
        }
    }

    .h5-why {
        padding: 60px 40px;
        padding-right: 100px;
        padding-bottom: 366px;
    }

    .h5-engine {
        padding: 60px 40px;

        &__box {
            margin-top: 76px;
            padding: 58px 72px;
            border-radius: 36px;
            background: #FFFFFF;
            box-shadow: 0px 24px 60px rgba(210, 198, 239, 0.78);
            border: 1px solid rgba(221, 212, 248, 0.92);
        }

        &__section {}

        &__head {
            display: flex;
            align-items: center;
            gap: 14px;
        }

        &__headIcon {
            width: 60px;
            height: 60px;
            flex: none;
        }

        &__headText {
            font-size: 20px;
            line-height: 1.4;
            font-weight: 600;
            color: #666666;
        }

        &__title {
            margin-top: 44px;
            font-size: 32px;
            font-weight: 700;
            color: #222222;
        }

        &__subTitle {
            margin-top: 12px;
            font-size: 16px;
            font-weight: 400;
            color: #666666;
        }

        &__subTitle--wide {
            padding-right: 4px;
        }

        &__live {
            margin-top: 33px;
            display: flex;
            align-items: center;
            gap: 8px;
        }

        &__liveDot {
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: #9345F5;
            box-shadow: 0px 0px 0px 9px rgba(0, 0, 0, 0), 0px 0px 10px 0px rgba(147, 69, 245, 0.9);
            flex: none;
        }

        &__liveText {
            font-size: 16px;
            line-height: 1;
            font-weight: 400;
            color: #6E7494;
        }

        &__wave {
            margin-left: 10px;
            display: flex;
            align-items: center;
            gap: 4px;
        }

        &__waveBar {
            display: inline-block;
            width: 3px;
            height: 16px;
            background: linear-gradient(180deg, #C9A7FF 0%, #9345F5 55%, #4E8DFF 100%);
            box-shadow: 0px 0px 8px rgba(147, 69, 245, 0.5);
            border-radius: 999px;
            transform-origin: center center;
            transform: scaleY(var(--scale));
            transition: transform 600ms ease;
        }

        &__radar {
            margin-top: 14px;
            display: flex;
            justify-content: center;
        }

        &__radarCanvas {
            width: 280px;
            height: 216px;
        }

        &__btn {
            padding: 10px 24px;
            margin: 20px auto 20px;
            width: fit-content;
            border-radius: 999px;
            background: #7C50FF;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            line-height: 1;
            font-weight: 600;
            color: #FFFFFF;
            cursor: pointer;
        }

        &__process {
            position: relative;
            overflow: hidden;
            margin: 24px auto 0;
            padding: 34px 18px 28px;
            border-radius: 22px;
            border: 1px solid #ECE0FC;
            background: #FFFFFF;
        }

        &__processGlow {
            position: absolute;
            top: 0;
            left: -120px;
            width: 120px;
            height: 100%;
            background: linear-gradient(90deg, #fff, #F0E6FF);
        }

        &__processGlow--active {
            animation: slideFullRightH5 4s ease-out forwards;
        }

        &__stepWrap {
            position: relative;
            z-index: 1;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
        }

        &__stepItem {
            width: 54px;
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        &__stepIconWrap {
            width: 54px;
            height: 54px;
        }

        &__stepIcon {
            display: block;
            width: 100%;
            height: 100%;
        }

        &__stepLabel {
            margin-top: 12px;
            font-size: 14px;
            line-height: 1;
            font-weight: 400;
            color: #222222;
        }

        &__arrow {
            margin-top: 10px;
            flex: none;

            i {
                font-size: 24px;
                font-weight: 600;
                color: #E1CAFF;
            }
        }
    }

    .h5-core {
        padding: 60px 40px 66px;

        &__list {
            margin-top: 76px;
            display: flex;
            flex-direction: column;
            gap: 24px;
        }

        &__item {
            min-height: 248px;
            padding: 37px 30px;
            border-radius: 32px;
            background: #FFFFFF;
            box-shadow: 0px 13px 27px 0px #DDDAE8;
            border: 1px solid #DAD5E8;
            display: flex;
            flex-direction: column;
        }

        &__icon {
            width: 52px;
            height: 52px;
            display: block;
        }

        &__title {
            margin-top: 28px;
            font-size: 32px;
            font-weight: 700;
            color: #222222;
        }

        &__desc {
            margin-top: 15px;
            font-size: 28px;
            line-height: 1.4;
            font-weight: 400;
            color: rgba(153, 153, 153, 0.92);
        }

        &__link {
            margin-top: 15px;
            font-size: 28px;
            line-height: 1;
            color: #7C50FF;
            cursor: pointer;
        }
    }

    .h5-run {
        padding: 60px 40px 66px;
        background-color: #F6F1FD;

        &__imgWrap {
            position: relative;
            margin-top: 60px;
        }

        &__img {
            display: block;
            width: 100%;
            height: auto;
        }

        &__line {
            position: absolute;
            top: 0px;
            left: 31px;
            width: 2px;
            background-color: #7C50FF;
        }

        &__line--active {
            animation: h5LineWidth 2s ease-out forwards;
        }
    }

    .h5-result {
        padding: 118px 40px 66px;

        &__card {
            margin-top: 76px;
            padding: 62px 27px;
            border-radius: 36px;
            border: 1px solid #DAD5E8;
            background: linear-gradient(159deg, #F8ECFF 0%, rgba(255, 255, 255, 0) 45%), #FFFFFF;
            box-shadow: 0px 24px 60px rgba(217, 210, 233, 0.68);
        }

        &__headline {
            display: flex;
            align-items: baseline;
            justify-content: center;
            gap: 8px;
            font-family: 'CustomFont';
            line-height: 1;
        }

        &__old,
        &__arrow,
        &__new {
            font-size: 88px;
            font-weight: 700;
        }

        &__old {
            position: relative;
            color: #6E7494;

            &::after {
                content: '';
                position: absolute;
                left: 6px;
                top: 50%;
                width: 100%;
                height: 4px;
                background: #7C50FF;
                transform: translateY(-50%) rotate(18deg);
            }
        }

        &__arrow,
        &__new,
        &__num {
            color: #7C50FF;
        }

        &__arrow {
            font-size: 60px;
        }

        &__meta {
            margin-top: 28px;
            font-size: 24px;
            line-height: 1.7;
            font-weight: 500;
            color: #8B8FA9;
            text-align: center;
        }

        &__list {
            margin: 0 46px;
            margin-top: 63px;
            padding-top: 60px;
            border-top: 1px solid #CCCCCC;
        }

        &__row {
            display: flex;
            align-items: center;
            gap: 14px;
            padding: 18px 0;
            margin: 0 60px;
            border-bottom: 1px solid #E9E5F2;

            &:last-child {
                border-bottom: none;
                padding-bottom: 0;
            }
        }

        &__num {
            flex: none;
            min-width: 92px;
            font-family: 'CustomFont';
            font-size: 32px;
            line-height: 1;
            font-weight: 700;
        }

        &__text {
            font-size: 18px;
            line-height: 1.6;
            font-weight: 500;
            color: #666666;
        }
    }

    .h5-news-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 24px;
        margin-top: 60px;

        &__card {
            background: var(--top-bg);
            border-radius: 24px;
            overflow: hidden;
            border: 1px solid #E5E1F0;
            padding: 0px 0px 24px;
            box-sizing: border-box;
            cursor: pointer;
            transition: all 0.3s ease;

            &--dark {
                border-color: rgba(214, 219, 246, 0.16);
            }
        }

        &__media {
            height: 185px;
            overflow: hidden;

            img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        &__body {
            padding: 22px 16px 0;
        }

        &__meta {
            font-size: 14px;
            line-height: 1.4;
            color: #8B8FA9;
        }

        &__title {
            margin-top: 10px;
            font-size: 22px;
            line-height: 1.45;
            font-weight: 700;
            color: var(--nav-text);
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }

        &__desc {
            margin-top: 10px;
            font-size: 14px;
            line-height: 1.6;
            color: rgba(153, 153, 153, 0.9);
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
    }

    .h5-news-more {
        display: block;
        margin: 48px auto 0;
        padding: 10px 20px;
        border-radius: 999px;
        font-size: 20px;
        line-height: 1;
        cursor: pointer;
        background: #FFFFFF;
        border: 1px solid #B79BFF;
        color: #7C50FF;
        transition: all 0.3s ease;

        &--dark {
            background: rgba(255, 255, 255, 0.04);
            border-color: rgba(214, 219, 246, 0.36);
            color: #EFF1FB;
        }
    }

    .h5-faq {
        display: flex;
        flex-direction: column;
        gap: 24px;
        margin-top: 60px;

        &__item {
            width: 100%;
            background: #fff;
            border: 1px solid #E5E1F0;
            border-radius: 24px;
            padding: 27px 23px;
            box-sizing: border-box;
            cursor: pointer;
            transition: border-color 0.3s ease;
        }

        &__head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 24px;
        }

        &__question {
            font-size: 20px;
            line-height: 1.5;
            font-weight: 700;
            color: #222;
        }

        &__icon {
            flex-shrink: 0;
            font-size: 40px;
            line-height: 1;
            color: #7C50FF;
        }

        &__answer {
            margin-top: 22px;
            font-size: 18px;
            line-height: 1.7;
            color: #666666;
        }
    }

    .h5-why-footer {
        position: relative;
        overflow: hidden;
        padding: 100px 102px;
        background-color: #F6F1FD;

        &__inner {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
        }

        &__title {
            font-size: 60px;
            line-height: 1.06;
            font-weight: 800;
        }

        &__titleBlack {
            color: #222222;
        }

        &__titlePurple {
            color: #7C50FF;
        }

        &__desc {
            margin-top: 29px;
            font-size: 32px;
            font-weight: 500;
            color: #666;
        }

        &__actions {
            margin-top: 63px;
            display: flex;
            gap: 10px;
        }

        &__btn {
            padding: 30px;
            border-radius: 999px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            line-height: 1;
            font-weight: 700;
            cursor: pointer;
        }

        &__btn--primary {
            border: none;
            color: #FFFFFF;
            background: linear-gradient(270deg, #6B3AFF 0%, #8B18FF 100%);
            box-shadow: 0px 10px 26px rgba(107, 58, 255, 0.24);
        }

        &__btn--outline {
            border: 1px solid #8F8A98;
            color: #8B8B8B;
            background: transparent;
        }

        &__linkRow {
            margin-top: 24px;
            font-size: 32px;
            line-height: 1.6;
            font-weight: 500;
            color: #666;
        }

        &__link {
            color: #9345F5;
            cursor: pointer;
        }
    }
}

@keyframes slideFullRightH5 {
    0% {
        left: -120px;
        opacity: 1;
    }

    90% {
        left: calc(100% - 120px);
        opacity: 1;
    }

    100% {
        left: calc(100% - 120px);
        opacity: 0;
    }
}

@keyframes h5LineWidth {
    0% {
        height: 0;
    }

    100% {
        height: 100%;
    }
}

@keyframes blinkPurple {
    0% {
        background-color: #7a28b8;
        box-shadow: 0 0 0 0 rgba(184, 108, 255, 0.4);
    }

    50% {
        background-color: #d8a8ff;
        box-shadow: 0 0 8px 2px rgba(184, 108, 255, 0.6);
    }

    100% {
        background-color: #7a28b8;
        box-shadow: 0 0 0 0 rgba(184, 108, 255, 0.3);
    }
}

.title-top {
    font-size: clamp(28px, 4vw, 42px);
    color: #b87dff;
    margin: 0 0 16px;
    font-weight: 600;
}

.main-title {
    margin-top: 40px;
    font-weight: 800;
    font-size: 88px;
    color: #F6F7FF;
    text-align: center;
}

.color-purple {
    background: linear-gradient(90deg, #0095FF, #863FFF 50%, #D65AFF);
    -webkit-background-clip: text;
    color: transparent;
}

.desc {
    width: 100%;
    font-weight: 400;
    font-size: 32px;
    color: #A59CC2;
    margin-top: 40px;
    margin-bottom: 91px;
}

.btn-group {
    display: flex;
    gap: 16px;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 133px;
}

.btn-primary {
    width: 200px;
    height: 68px;
    background: linear-gradient(270deg, #6B3AFF 0%, #8B18FF 100%);
    box-shadow: 0px 6px 25px 0px #4523A8;
    border-radius: 60px 60px 60px 60px;
    text-align: center;
    font-size: 20px;
    color: #FFFFFF;
    z-index: 9;
    cursor: pointer;
}

.btn-outline {
    width: 200px;
    height: 68px;
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
    border-radius: 60px 60px 60px 60px;
    border: 1px solid #4B4852;
    font-weight: 400;
    font-size: 20px;
    color: rgba(240, 242, 255, 0.72);
    cursor: pointer;
}

.stats-wrap {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    z-index: 2;
    width: 100%;
    height: 230px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.3);
    border-top: 1px dashed rgba(255, 255, 255, 0.2);

    // padding-top: 36px;
    &>div {
        width: 1200px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

.stat-item {
    flex: 1;
    min-width: 140px;
    text-align: center;
    padding: 20px 10px;
}

.num {
    font-family: 'CustomFont';
    font-size: 60px;
    color: #ffffff;
    font-weight: bold;
}

.unit {
    font-size: 30px;
    color: #c29dff;
}

.label {
    font-size: 20px;
    color: #ffffff;
    margin-top: 8px;
}

.sub-label {
    font-size: 16px;
    color: #9986b8;
    margin-top: 6px;
}

.content {
    background-color: var(--header-bg);
    transition: background-color 0.3s ease, color 0.3s ease;
    margin: 0 auto;

    .top_1 {
        background-color: var(--top-bg);
    }

    .why {
        max-width: 1200px;
        margin: 0 auto;
        padding: 91px 20px 98px 32px;

        .span {
            font-weight: 600;
            font-size: 16px;
            color: #6E7494;
        }

        .title_1 {
            font-weight: 800;
            font-size: 60px;
            line-height: 1;
            color: var(--nav-text);
            margin-bottom: 30px;
        }

        .desc {
            font-weight: 400;
            font-size: 20px;
            color: var(--nav-text);

            margin-bottom: 0px !important;
        }

        .box_1 {
            display: flex;
            align-items: center;

            .left {
                width: 631px;
                height: 330px;
                background: #F7F7F7;
                border-radius: 32px 32px 32px 32px;
                border: 1px solid #D8CBFF;

                .left_text {
                    padding: 52px 100px;

                    .h1_title {
                        font-weight: 600;
                        font-size: 24px;
                        color: #6E7494;
                        margin-bottom: 27px;
                    }

                    .item {
                        display: flex;
                        gap: 50px;
                        font-weight: 600;
                        font-size: 20px;
                        color: #6E7494;
                    }
                }
            }

            .right {
                width: 591px;
                height: 465px;
                background: url('https://file.zmxs.com.cn/img/2026-09-0800007.png') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
                border-radius: 32px 32px 32px 32px;
                margin-top: -40px;
                margin-left: -50PX;
                padding: 133px 83px;
                color: #fff;

                .h1_title {
                    font-weight: 600;
                    font-size: 32px;
                    color: #fff;
                    margin-bottom: 27px;
                }

                .item {
                    display: flex;
                    gap: 30px;
                    font-weight: 600;
                    font-size: 20px;
                    color: #fff;
                }
            }
        }
    }

    .two {
        background-color: var(--two-bg);
        height: 1032px;

        .title_1 {
            font-weight: 800;
            font-size: 60px;
            line-height: 1;
            color: var(--nav-text);
            margin-bottom: 30px;
        }

        .box_2 {
            display: flex;
            width: 1130px;
            background: #FFFFFF;
            border-radius: 32px;
            margin-top: 77px;
            box-shadow: var(--card-shadow);

            .left {
                width: 557px;
                padding: 27px 43px;
                border-right: .5px solid #edeaf6;

                .title {
                    display: flex;
                    align-items: center;
                    gap: 14px;
                    margin-bottom: 40px;

                    img {
                        width: 60px;
                        height: 60px;
                    }

                    span {
                        font-weight: 600;
                        font-size: 20px;
                        color: #666666;
                    }
                }

                .h1_title {
                    margin-bottom: 32px;

                    h3 {
                        font-weight: 700;
                        font-size: 32px;
                        color: #222222;
                        margin-bottom: 12px;
                    }

                    span {
                        font-weight: 400;
                        font-size: 16px;
                        color: #666666;
                    }
                }

                .ldChart {
                    .ld_title {
                        display: flex;
                        align-items: center;
                        gap: 10px;

                        .dian {
                            width: 7px;
                            height: 7px;
                            background: #9345F5;
                            box-shadow: 0px 0px 0px 9px rgba(0, 0, 0, 0), 0px 0px 10px 0px rgba(147, 69, 245, 0.9);
                            border-radius: 4px 4px 4px 4px;
                        }

                        .text {
                            font-weight: 400;
                            font-size: 16px;
                            color: #6E7494;
                        }

                        .num {
                            display: inline-block;
                            width: 4px;
                            height: 40px;
                            background: linear-gradient(180deg, #C9A7FF 0%, #9345F5 55%, #4E8DFF 100%);
                            box-shadow: 0px 0px 8px 0px rgba(147, 69, 245, 0.5);
                            border-radius: 2px;
                            transform-origin: center center;
                            transform: scaleY(var(--scale));
                            transition: transform 600ms ease;
                            margin-right: 4px;
                        }

                        @keyframes wave {
                            0% {
                                transform: scaleY(0.3);
                            }

                            100% {
                                transform: scaleY(1);
                            }
                        }
                    }
                }
            }

            .radar-box {
                display: flex;
                justify-content: center;
            }

            .AiBtn {
                width: 120px;
                height: 36px;
                background: #7C50FF;
                border-radius: 60px 60px 60px 60px;

                font-weight: 600;
                font-size: 15px;
                color: #FFFFFF;
                margin: 0 auto;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                margin-bottom: 16px;
            }

            .card {
                width: 500px;
                height: 202px;
                background: #FFFFFF;
                border-radius: 28px;
                border: 1px solid #ECE0FC;
                margin: 0 auto;
                display: flex;
                align-items: center;
                margin-bottom: 88px;
                margin-top: 82px;
                overflow: hidden;
                position: relative;

                .bg-gradient-bar {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 120px;
                    height: 100%;
                    background: linear-gradient(90deg, #fff, #F0E6FF);
                    transform: translateX(-100%);
                }

                .barAnimate {
                    animation: slideFullRight 4s ease-out forwards;
                }

                .step-wrap {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 20px;
                    z-index: 2;
                    position: relative;
                }

                .step-item {
                    flex: 1;
                    display: flex;
                    justify-content: center;
                }

                .arrow {
                    margin-top: -26px;

                    i {
                        font-size: 34px;
                        font-weight: 600;
                        color: #E1CAFF;
                    }
                }

                .img-box {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 12px;

                    img {
                        width: 60px;
                        height: 60px;
                    }

                    span {
                        font-weight: 400;
                        font-size: 16px;
                        color: #222222;
                    }
                }
            }

            // 新动画：色块从左 → 滑到卡片最右侧 → 消失，总时长4s
            @keyframes slideFullRight {
                0% {
                    transform: translateX(-100%);
                    opacity: 1;
                }

                90% {
                    transform: translateX(calc(500px - 120px));
                    opacity: 1;
                }

                100% {
                    transform: translateX(calc(500px - 120px));
                    opacity: 0;
                }
            }

        }
    }

    .two1 {
        background-color: var(--two-bg);

        height: 690px;

        // margin: 0 auto;
        .title_1 {
            font-weight: 800;
            font-size: 60px;
            line-height: 1;
            color: var(--nav-text);
            margin-bottom: 30px;
        }

        .box_2 {
            display: flex;
            width: 1130px;
            background: #FFFFFF;
            border-radius: 32px;
            margin-top: 77px;
            // 添加边框阴影
            box-shadow: var(--card-shadow);

            .left {
                width: 557px;
                padding: 27px 43px;
                border-right: .5px solid #edeaf6;

                .title {
                    display: flex;
                    align-items: center;
                    gap: 14px;
                    margin-bottom: 40px;

                    img {
                        width: 60px;
                        height: 60px;
                    }

                    span {
                        font-weight: 600;
                        font-size: 16px;
                        color: #666666;
                    }
                }

                .h1_title {
                    margin-bottom: 32px;

                    h3 {
                        font-weight: 700;
                        font-size: 32px;
                        color: #222222;
                        margin-bottom: 12px;
                    }

                    span {
                        font-weight: 400;
                        font-size: 16px;
                        color: #666666;
                    }
                }

                .ldChart {
                    .ld_title {
                        display: flex;
                        align-items: center;
                        gap: 10px;

                        .dian {
                            width: 7px;
                            height: 7px;
                            background: #9345F5;
                            box-shadow: 0px 0px 0px 9px rgba(0, 0, 0, 0), 0px 0px 10px 0px rgba(147, 69, 245, 0.9);
                            border-radius: 4px 4px 4px 4px;
                        }

                        .text {
                            font-weight: 400;
                            font-size: 16px;
                            color: #6E7494;
                        }

                        .num {
                            display: inline-block;
                            width: 4px;
                            height: 40px;
                            background: linear-gradient(180deg, #C9A7FF 0%, #9345F5 55%, #4E8DFF 100%);
                            box-shadow: 0px 0px 8px 0px rgba(147, 69, 245, 0.5);
                            border-radius: 2px;
                            transform-origin: center center;
                            transform: scaleY(var(--scale));
                            transition: transform 600ms ease;
                            margin-right: 4px;
                        }

                        @keyframes wave {
                            0% {
                                transform: scaleY(0.3);
                            }

                            100% {
                                transform: scaleY(1);
                            }
                        }
                    }
                }
            }

            .radar-box {
                display: flex;
                justify-content: center;
            }

            .AiBtn {
                width: 120px;
                height: 36px;
                background: #7C50FF;
                border-radius: 60px 60px 60px 60px;
                font-weight: 600;
                font-size: 15px;
                color: #FFFFFF;
                margin: 0 auto;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                margin-bottom: 16px;
            }

            .card {
                width: 500px;
                height: 202px;
                background: #FFFFFF;
                border-radius: 28px;
                border: 1px solid #ECE0FC;
                margin: 0 auto;
                display: flex;
                align-items: center; // 垂直居中，把流程区域放在卡片中间
                margin-bottom: 88px;
                margin-top: 82px;

                .step-wrap {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 20px;
                }

                .step-item {
                    flex: 1;
                    /* 四个步骤1:1等分宽度 */
                    display: flex;
                    justify-content: center;
                }

                .arrow {
                    margin-top: -26px;

                    i {
                        font-size: 34px;
                        font-weight: 600;
                        color: #E1CAFF;
                    }
                }

                .img-box {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 12px;

                    img {
                        width: 60px;
                        height: 60px;
                    }

                    span {
                        font-weight: 400;
                        font-size: 16px;
                        color: #222222;
                    }
                }
            }
        }
    }

    .two2 {
        background-color: var(--two-bg);

        height: 500px;

        display: flex;
        align-items: center;
        justify-content: center;
    }

    .content-wrap1 {
        // width: 90%;
        // max-width: 1200px;
        display: flex;
        justify-content: center;
        align-items: center;
        // margin-left: 18%;
        // justify-content: end;
        // gap: 80px;
    }

    .left-text {
        width: 551px;
        text-align: center;
    }

    .title {
        font-weight: 800;
        font-size: 60px;
        line-height: 1;
        color: var(--nav-text);
    }

    .black-text {
        color: var(--nav-text);
    }

    .purple-text {
        color: #7C50FF;
    }

    .sub-title {
        font-weight: 400;
        font-size: 20px;
        color: var(--nav1-text);
        margin-top: 29px;
        margin-bottom: 84px;
    }

    .btn-group {
        display: flex;
        gap: 12px;
        justify-content: center;
        margin-bottom: 23px;
    }

    .btn-primary {
        width: 200px;
        height: 68px;
        color: #fff;
        font-size: 20px;
        background: linear-gradient(270deg, #6B3AFF 0%, #8B18FF 100%);
        box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
        border-radius: 60px 60px 60px 60px;
    }

    .btn-outline {
        width: 200px;
        height: 68px;
        box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
        border-radius: 60px 60px 60px 60px;
        border: 1px solid #4B4852;
        font-size: 20px;
        color: #666;
    }

    .link-row {
        font-size: 20px;
        color: var(--nav1-text);
    }

    .link-text {
        color: #9345F5;
        cursor: pointer;
    }

    .right-illu {
        width: 190px;
        margin-left: 56px;
        text-align: center;
        // margin-left: 160px;
        // margin-right: -50px;
    }

    .illus-box {
        width: 188px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-weight: 400;
        font-size: 16px;
        color: rgba(102, 102, 102, 0.72);
        /* 这里放上你的插画图片即可 */
    }

    .tip1 {
        font-weight: 400;
        font-size: 17px;
        margin-top: 16px;
        padding-left: 20px;
        color: rgba(102, 102, 102, 0.72);
    }

    .tip2 {
        font-size: 16px;
        color: #555b6b;
        font-weight: 700;
        padding-left: 20px;
        margin: 6px 0;

        &>div {
            text-align: center;
            line-height: 24px;
        }
    }

    .tip3 {
        padding-left: 20px;
        font-size: 17px;
        color: #666;

        &>div {
            text-align: center;
            line-height: 24px;
        }
    }

    .feature-wrap {
        display: flex;
        gap: 24px;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 52px;
    }

    .news-card-mini {
        flex: 1;
        background: var(--top-bg);
        border-radius: 16px;
        border: 1px solid #DDDDDD;
        padding: 0px 0px 26px;
        overflow: hidden;
        box-sizing: border-box;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
            transform: translateY(-4px);
            box-shadow: rgba(147, 69, 245, 0.2) 12px 24px 44px;
            border-color: rgba(147, 69, 245, 0.55);
        }

        &--dark {
            border: 1px solid #8288BC;
            background: #141737;
        }

        &__media {
            height: 205px;
            border-radius: 20px 20px 0 0;
            overflow: hidden;
            border: 1px solid #DDDDDD;
            border-bottom: none;
            padding: 1px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        &__body {
            padding: 18px 14px 0;
        }

        &__meta {
            font-size: 14px;
            line-height: 1.4;
            color: #8B8FA9;
        }

        &__title {
            margin-top: 10px;
            font-size: 16px;
            line-height: 1.45;
            font-weight: 700;
            color: var(--nav-text);
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }

        &__desc {
            margin-top: 10px;
            font-size: 14px;
            line-height: 1.6;
            color: rgba(153, 153, 153, 0.9);
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
    }

    .news-more-wrap {
        flex: 0 0 100%;
        margin-top: 44px;
        text-align: center;
    }

    .news-more-btn {
        padding: 11px 30px;
        border-radius: 999px;
        cursor: pointer;
        font-size: 15px;
        line-height: 1;
        background: #FFFFFF;
        border: 1px solid #B79BFF;
        color: #7C50FF;
        transition: all 0.3s ease;

        &:hover {
            background: #7C50FF;
            color: #FFFFFF;
        }

        &--dark {
            background: rgba(255, 255, 255, 0.04);
            border-color: rgba(214, 219, 246, 0.36);
            color: #EFF1FB;

            &:hover {
                background: #7C50FF;
                border-color: #7C50FF;
                color: #FFFFFF;
            }
        }
    }

    .faq-wrap {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
        margin: 48px auto 0;
    }

    .faq-item {
        width: 100%;
        background: var(--top-bg);
        border: 1px solid #E5E1F0;
        border-radius: 16px;
        padding: 22px 28px;
        box-sizing: border-box;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
            border-color: rgba(124, 80, 255, 0.45);
        }

        &--dark {
            border-color: rgba(214, 219, 246, 0.16);
        }

        &__head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 20px;
        }

        &__question {
            font-size: 20px;
            font-weight: 600;
            line-height: 1.5;
            color: var(--nav-text);
        }

        &__icon {
            flex-shrink: 0;
            font-size: 22px;
            line-height: 1;
            color: #7C50FF;
        }

        &__answer {
            margin-top: 14px;
            font-size: 18px;
            line-height: 1.7;
            color: var(--nav-text);
        }

        &--dark &__answer {
            color: rgba(214, 219, 246, 0.72);
        }
    }

    .card_1 {
        width: 266px;
        height: 329px;
        background: var(--top-bg);
        border-radius: 32px;
        border: 1px solid #DAD5E8;
        padding: 32px 31px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        /* 开启过渡动画 所有属性0.3秒缓动 */
        transition: all 0.3s ease;

        img {
            width: 64px;
            height: 64px;
            /* 图片缩放过渡 */
            transition: transform 0.3s ease;
        }

        h3 {
            font-size: 24px;
            color: var(--nav-text);
            font-weight: 500;
            margin: 27px 0 12px 0;
        }

        p {
            flex: 1;
            font-weight: 400;
            font-size: 16px;
            color: rgba(153, 153, 153, 0.9);
            margin: 0;
            line-height: 1.3;
        }

        .link-btn {
            font-weight: 600;
            font-size: 16px;
            color: #7C50FF;
            cursor: pointer;
            /* 箭头位移过渡 */
            transition: transform 0.3s ease;
        }

        /* hover悬浮效果 */
        &:hover {
            /* 卡片向上移动4px */
            transform: translateY(-4px);
            /* 阴影效果 */
            box-shadow: rgba(147, 69, 245, 0.2) 12px 24px 44px;
            border-color: rgba(147, 69, 245, 0.55);

            img {
                /* 图标放大2px,原图64px → 放大后66px */
                transform: scale(1.04125);
            }

            .link-btn {
                /* 按钮文字整体向右偏移2px */
                transform: translateX(4px);
            }
        }
    }

    .span-title {
        font-weight: 600;
        font-size: 16px;
        color: #6E7494;
    }

    .card_item {
        width: 1136px;
        height: 378px;
        /* 原图渐变背景 */
        background: linear-gradient(159deg, #FEE2FF 0%, rgba(255, 255, 255, 0) 40%), #FFFFFF;
        box-shadow: var(--item-border);
        border-radius: 32px;
        border: 1px solid #DAD5E8;
        margin-top: 78px;

        /* 弹性布局左右分栏 */
        display: flex;
        align-items: center;
        padding: 0 64px;
        box-sizing: border-box;
        gap: 60px;
    }

    .left-wrap {
        flex: 1;
    }

    .big-num {
        font-weight: 400;
        font-size: 70px;
        color: #7C50FF;

        .span {
            font-weight: normal;
            position: relative;
            display: inline-block;
            color: #6E7494;
            font-size: 70px;
            display: inline-block;
            // margin-right: 2px;
            color: #6E7494;

            &::after {
                content: '';
                position: absolute;
                left: 10px;
                top: 35%;
                width: 100%;
                height: 4px;
                background-color: #7C50FF;
                /* 倾斜角度，可修改 15deg~25deg */
                transform: rotate(20deg);
            }
        }
    }

    /* 箭头和11天紫色 */


    .desc-text {
        margin-top: 20px;
        font-weight: 400;
        font-size: 16px;
        color: #6E7494;
    }

    .divider {
        width: 1px;
        height: 200px;
        background-color: #DAD5E8;
    }

    .right-wrap {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 36px;
    }

    .data-row {
        display: flex;
        align-items: center;
        gap: 14px;
        padding-bottom: 32px;
        border-bottom: 1px solid #E9E5F2;
    }

    /* 最后一行不要下边框 */
    .data-row:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }

    .purple-num {
        font-size: 32px;
        font-weight: 700;
        color: #7C50FF;
        white-space: nowrap;
    }

    .text-label {
        font-size: 20px;
        color: #666;
    }
}

.tip1,
.tip2,
.tip3 {
    opacity: 0;
    transition: opacity 0.5s ease;
}

.tip1.show,
.tip2.show,
.tip3.show {
    opacity: 1;
}

.line {
    position: absolute;
    top: 60px;
    left: 30px;
    width: 0;
    height: 2px;
    background-color: #7C50FF;
}

.animateLine {
    animation: lineWidth 2s ease-out forwards;
}

@keyframes lineWidth {
    0% {
        width: 0;
    }

    100% {
        width: 1110px;
    }
}
</style>
